// Cookie Consent
function addConsentForCookieGroup(event, groupName) {
    let form = document.querySelector('#elc-cookie-consent-form');
    const input = form.querySelector('input[name="group-' + groupName + '"]');

    if (input !== null) {
        input.checked = true;
    }

    submitConsent(event);
}

function enableVideosIfConsentGiven(consent) {
    if (consent['marketing']) {
        document.querySelectorAll('.youtube-video .on-marketing-consent-given').forEach((elem) => {
            elem.classList.remove('d-none');
        });

        document.querySelectorAll('.youtube-video .marketing-consent-notice').forEach((elem) => {
            elem.remove();
        });
    }
}

(function () {
    // Load initial cookie consent state with Fetch to bypass Cloudfront caching
    const cookieForm = document.getElementById('elc-cookie-consent-form');
    const dataUrl = cookieForm?.dataset.show;
    if (dataUrl && cookieForm) {
        fetch(dataUrl)
            .then((r) => r.json())
            .then((data) => {
                if (data === null) {
                    const modal = document.getElementById('elc-cookie-consent');
                    modal?.classList.remove('elc-hidden');
                    return;
                }

                const cookieTypes = ['necessary', 'statistics', 'marketing'];
                const uidInput = cookieForm.querySelector(`input[name="uid"]`);
                if (uidInput) {
                    uidInput.value = data.consent_uid;
                }

                cookieTypes.forEach((type) => {
                    cookieForm.querySelector(`input[name="group-${type}"]`).checked = data[type] ?? true;
                });

                // Update GTM Consent
                gtag('consent', 'update', {
                    ad_storage: data['marketing'] ? 'granted' : 'denied',
                    analytics_storage: data['statistics'] ? 'granted' : 'denied'
                });

                enableVideosIfConsentGiven(data);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    // Allow to submit the consent form by clicking on a link (for video embeds)
    document.querySelectorAll('#cookie-consent-marketing').forEach((elem) => {
        elem.addEventListener('click', (event) => {
            addConsentForCookieGroup(event, 'marketing');
        });
    });

    // Allow to open the consent modal by clicking on a link on cookie policy page
    document.getElementById('open-cookie-modal')?.addEventListener('click', (event) => {
        event.preventDefault();
        const modal = document.getElementById('elc-cookie-consent');
        modal.classList.add('elc-small');
        modal.classList.remove('elc-hidden');
        modal.classList.remove('elc-fullwidth');
    });

    // Handle bootstrap toggles in the cookie modal
    const cookiesDetailsToggles = document.querySelectorAll('.cookie-details-toggle');
    cookiesDetailsToggles.forEach((elem) => {
        elem.addEventListener('click', (event) => {
            const targetId = event.target.dataset.bsTarget;
            cookiesDetailsToggles.forEach((toggle) => {
                if (toggle.dataset.bsTarget !== targetId && !toggle.classList.contains('collapsed')) {
                    toggle.click();
                }
            });
        });
    });
})();
